/**
 * Issue Types API
 *
 * Fetches dynamic issue type definitions from the backend.
 */

import { apiGet } from "@/lib/api-client";

export interface IssueType {
    issue_type_id: string;
    slug: string;
    label: string;
    description: string | null;
    category: string;
    risk_component: string;
    is_system: boolean;
}

interface IssueTypesResponse {
    issue_types: IssueType[];
    count: number;
}

export async function fetchIssueTypes(category?: string): Promise<IssueType[]> {
    const params: Record<string, string> = {};
    if (category) params.category = category;
    const res = await apiGet<IssueTypesResponse>("/issue-types", { params });
    return res.issue_types;
}
